import { useMemo } from 'react';
import { Typography } from '@mui/material';

import { MENU_ITEMS } from '@config/menu';
import { isFfdProject } from '@helpers/projects';
import { filterNavigationMenuItemByProject } from '@helpers/navigation-menu';
import { useTypedSelector } from '@hooks/store';
import { projectsGetCurrentProjectName } from '@selectors/projects';

import { NavigationGroup } from '@kit/navigation/navigation-group';

export const MainLayoutSidebarMenuList: React.FC = () => {
  const currentProjectName = useTypedSelector(projectsGetCurrentProjectName);
  const navItems = useMemo(() => {
    const isFfd = isFfdProject(currentProjectName);

    return MENU_ITEMS.items.map((item) => {
      const filteredItem = filterNavigationMenuItemByProject(item, isFfd);

      switch (filteredItem.type) {
        case 'group':
          return <NavigationGroup key={filteredItem.id} item={filteredItem} />;
        default:
          return (
            <Typography
              key={filteredItem.id}
              variant="h6"
              color="error"
              align="center"
            >
              Menu Items Error
            </Typography>
          );
      }
    });
  }, [currentProjectName]);

  return <>{navItems}</>;
};
